import { StepType, TourProvider } from '@reactour/tour';
import { noop } from 'lodash-es';
import { ComponentProps } from 'preact/compat';

import AppOnboarding from '@/components/AppOnboarding';
import FreeHabitatSelectorModal from '@/components/FreeHabitatsSelector/FreeHabitatSelectorModal';
import Header from '@/components/Header';
import { LayoutDetector } from '@/components/LayoutDetector';
import { useIsDesktopLayout } from '@/components/LayoutDetector/hooks';
import LiveChannelsBar from '@/components/LiveChannelsBar';
import PageWrapper from '@/components/Main/PageWrapper';
import PubNubWrapper from '@/components/PubNubWrapper';

import CommunityFeedCard from './CommunityFeedCard';
import HomeContent from './HomeContent';
import SpotlightFreeHabitats from './SpotlightFreeHabitats';
import UpcomingEventsCard from './UpcomingEventsCard';

const Home = () => {
  const isDesktop = useIsDesktopLayout();
  return (
    <div className="relative grid h-full grid-cols-1 overflow-x-hidden fullscreen:block mobile:w-full desktop:grid-cols-[64px_2fr_minmax(340px,1fr)]">
      <aside className="preflight relative z-[11] h-full border-r fullscreen:hidden mobile:hidden">
        {/* We keep the wrapper exists to keep virtual DOM structure as much as possible */}
        {isDesktop && (
          <PubNubWrapper>
            <LiveChannelsBar />
          </PubNubWrapper>
        )}
      </aside>
      <main className="h-full overflow-y-auto">
        <HomeContent />
      </main>
      <aside className="preflight grid h-full grid-rows-[repeat(2,minmax(300px,1fr))] gap-3 overflow-y-auto border-l p-3 shadow-md fullscreen:hidden mobile:hidden">
        {/* We keep the wrapper exists to keep virtual DOM structure as much as possible */}
        {isDesktop && (
          <>
            <UpcomingEventsCard />
            <CommunityFeedCard />
          </>
        )}
      </aside>
      <AppOnboarding />
      <FreeHabitatSelectorModal />
      <SpotlightFreeHabitats />
    </div>
  );
};

const PLACEHOLDER_STEPS: StepType[] = [];

const HomeWithLayout = () => {
  const tourProps: Omit<ComponentProps<typeof TourProvider>, 'children'> = {
    steps: PLACEHOLDER_STEPS,
    showCloseButton: false,
    disableDotsNavigation: true,
    disableKeyboardNavigation: true,
    disableInteraction: true,
    disableFocusLock: true,
    showBadge: false,
    ContentComponent: SpotlightFreeHabitats.TourContent,
    onClickMask: noop,
  };
  return (
    <LayoutDetector
      title="Home"
      breakPoint={1023} // keep it as stable as possible in mobile device to prevent layout change when orientation changes
      desktop={
        // eslint-disable-next-line react/jsx-props-no-spreading
        <TourProvider padding={{ mask: 8 }} {...tourProps}>
          <Header />
          <PageWrapper>
            <Home />
          </PageWrapper>
        </TourProvider>
      }
      mobile={
        // eslint-disable-next-line react/jsx-props-no-spreading
        <TourProvider padding={{ mask: 0 }} {...tourProps}>
          <Home />
        </TourProvider>
      }
    />
  );
};

export default HomeWithLayout;
